module.exports = __webpack_public_path__ + "img/tipos.d6016a44.webp";